/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../banking/common';
import '../../models/folder_recommendation';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ListRecommendedFoldersRequest": {
                    "fields": {
                      "owner": {
                        "type": ".squareup.banking.Owner",
                        "id": 1,
                        "rule": "optional"
                      },
                      "limit": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": 50
                        }
                      },
                      "cursor": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListRecommendedFoldersResponse": {
                    "fields": {
                      "recommendedFolders": {
                        "type": ".squareup.sfs.external.models.FolderRecommendation",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "mcc": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cursor": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 4,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListRecommendedFoldersRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ListRecommendedFoldersResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPC for recommending folders.
 * --
 *
 * SOURCE ListRecommendedFoldersRequest @ squareup/sfs/external/services/folder_recommendation/list_recommended_folders.proto at 14:1
 */
export const ListRecommendedFoldersRequest = $root.lookupType('squareup.sfs.external.service.ListRecommendedFoldersRequest');
fixType(ListRecommendedFoldersRequest, {
  owner: {
    required: true
  }
});
Builder.createAndAttachToType(ListRecommendedFoldersRequest);
/**
 * SOURCE ListRecommendedFoldersResponse @ squareup/sfs/external/services/folder_recommendation/list_recommended_folders.proto at 36:1
 */
export const ListRecommendedFoldersResponse = $root.lookupType('squareup.sfs.external.service.ListRecommendedFoldersResponse');
fixType(ListRecommendedFoldersResponse);
Builder.createAndAttachToType(ListRecommendedFoldersResponse);